import baseService from './apiService';
import { Get_Token } from 'resolvers/Get_Token';

export async function getCardTransactions(queryParams) {
    const response = await baseService.get(`/transactions/cards`, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        },
        params: queryParams
    });
    return response.data;
}

export async function getTransactionsByDate(startDate, endDate) {
    const response = await baseService.get('/transactions/cards/', {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        },
        params: {
            startDate: startDate,
            endDate: endDate
        }
    });
    return response.data;
}

export async function fetchTransactionCSV() {
    const response = await baseService.get(`/transactions/cards/csv`, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
}

export async function fetchTransactionCSVByDate(queryParams) {
    const response = await baseService.get(`/transactions/cards/csv/`, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        },
        params: queryParams
    });
    return response.data;
}

export async function getPaymentHistory({ page = 0, limit = 10 }) {
    const response = await baseService.get(`/transactions/ach/pull`, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        },
        params: {
            page,
            limit
        }
    });
    return response.data;
}

export async function getACHCardTransactions(id) {
    const response = await baseService.get(`/transactions/${id}/cards-transactions`, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
}
